<template>
    <svg
        width="660"
        height="440"
        viewBox="0 0 660 440"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 145C0 138.373 5.37258 133 12 133H202.667C209.294 133 214.667 138.373 214.667 145V386C214.667 392.627 209.294 398 202.667 398H12C5.3726 398 0 392.627 0 386V145Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M234.667 133.5H425.334C431.685 133.5 436.834 138.649 436.834 145V386C436.834 392.351 431.685 397.5 425.334 397.5H234.667C228.316 397.5 223.167 392.351 223.167 386V145C223.167 138.649 228.316 133.5 234.667 133.5Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M445.333 145C445.333 138.373 450.706 133 457.333 133H648C654.627 133 660 138.373 660 145V386C660 392.627 654.627 398 648 398H457.333C450.706 398 445.333 392.627 445.333 386V145Z"
            fill="var(--et-colors-card-background)"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-1px"
        >
            <tspan x="276.676" y="58.2001">Pricing</tspan>
        </text>
        <text
            fill="#475467"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="228.398" y="90.2001">Choose best option for you.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="16" y="160.4">Base</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="16" y="190.8">$29</tspan>
        </text>
        <path
            d="M24 350.5H190.667C194.809 350.5 198.167 353.858 198.167 358V374C198.167 378.142 194.809 381.5 190.667 381.5H24C19.8579 381.5 16.5 378.142 16.5 374V358C16.5 353.858 19.8579 350.5 24 350.5Z"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M234.667 133.5H425.334C431.685 133.5 436.834 138.649 436.834 145V386C436.834 392.351 431.685 397.5 425.334 397.5H234.667C228.316 397.5 223.167 392.351 223.167 386V145C223.167 138.649 228.316 133.5 234.667 133.5Z"
            stroke="var(--et-colors-brand)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="238.667" y="160.4">Standard</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="238.667" y="190.8">$49</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="293.667" y="186.9">$59</tspan>
        </text>
        <path
            d="M27.3337 302.667L20.667 309.333M20.667 302.667L27.3337 309.333M27.3337 322.667L20.667 329.333M20.667 322.667L27.3337 329.333M250.001 322.667L243.334 329.333M243.334 322.667L250.001 329.333"
            stroke="#D92D20"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M246.667 350.5H413.334C417.476 350.5 420.834 353.858 420.834 358V374C420.834 378.142 417.476 381.5 413.334 381.5H246.667C242.525 381.5 239.167 378.142 239.167 374V358C239.167 353.858 242.525 350.5 246.667 350.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M246.667 350.5H413.334C417.476 350.5 420.834 353.858 420.834 358V374C420.834 378.142 417.476 381.5 413.334 381.5H246.667C242.525 381.5 239.167 378.142 239.167 374V358C239.167 353.858 242.525 350.5 246.667 350.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="304.5" y="370.3">Choose</tspan>
        </text>
        <path
            d="M356.667 121.5H301.667C295.316 121.5 290.167 126.649 290.167 133C290.167 139.351 295.316 144.5 301.667 144.5H356.667C363.018 144.5 368.167 139.351 368.167 133C368.167 126.649 363.018 121.5 356.667 121.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M356.667 121.5H301.667C295.316 121.5 290.167 126.649 290.167 133C290.167 139.351 295.316 144.5 301.667 144.5H356.667C363.018 144.5 368.167 139.351 368.167 133C368.167 126.649 363.018 121.5 356.667 121.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="299.964" y="136.9">Bestseller</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="461.333" y="160.4">Premium</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="461.333" y="190.8">$69</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="516.333" y="186.9">$79</tspan>
        </text>
        <path
            d="M29.3337 282L22.0003 289.333L18.667 286M252.001 282L244.667 289.333L241.334 286M252.001 302L244.667 309.333L241.334 306M474.667 282L467.333 289.333L464 286M474.667 302L467.333 309.333L464 306M474.667 322L467.333 329.333L464 326"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M192.667 214H22C18.6863 214 16 216.686 16 220C16 223.314 18.6863 226 22 226H192.667C195.981 226 198.667 223.314 198.667 220C198.667 216.686 195.981 214 192.667 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M132 234H22C18.6863 234 16 236.686 16 240C16 243.314 18.6863 246 22 246H132C135.314 246 138 243.314 138 240C138 236.686 135.314 234 132 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M166 280H42C38.6863 280 36 282.686 36 286C36 289.314 38.6863 292 42 292H166C169.314 292 172 289.314 172 286C172 282.686 169.314 280 166 280Z"
            fill="#F2F4F7"
        />
        <path
            d="M114 300H42C38.6863 300 36 302.686 36 306C36 309.314 38.6863 312 42 312H114C117.314 312 120 309.314 120 306C120 302.686 117.314 300 114 300Z"
            fill="#F2F4F7"
        />
        <path
            d="M139 320H42C38.6863 320 36 322.686 36 326C36 329.314 38.6863 332 42 332H139C142.314 332 145 329.314 145 326C145 322.686 142.314 320 139 320Z"
            fill="#F2F4F7"
        />
        <path
            d="M415.334 214H244.667C241.353 214 238.667 216.686 238.667 220C238.667 223.314 241.353 226 244.667 226H415.334C418.648 226 421.334 223.314 421.334 220C421.334 216.686 418.648 214 415.334 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M384.667 234H244.667C241.353 234 238.667 236.686 238.667 240C238.667 243.314 241.353 246 244.667 246H384.667C387.981 246 390.667 243.314 390.667 240C390.667 236.686 387.981 234 384.667 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M388.667 280H264.667C261.353 280 258.667 282.686 258.667 286C258.667 289.314 261.353 292 264.667 292H388.667C391.981 292 394.667 289.314 394.667 286C394.667 282.686 391.981 280 388.667 280Z"
            fill="#F2F4F7"
        />
        <path
            d="M336.667 300H264.667C261.353 300 258.667 302.686 258.667 306C258.667 309.314 261.353 312 264.667 312H336.667C339.981 312 342.667 309.314 342.667 306C342.667 302.686 339.981 300 336.667 300Z"
            fill="#F2F4F7"
        />
        <path
            d="M361.667 320H264.667C261.353 320 258.667 322.686 258.667 326C258.667 329.314 261.353 332 264.667 332H361.667C364.981 332 367.667 329.314 367.667 326C367.667 322.686 364.981 320 361.667 320Z"
            fill="#F2F4F7"
        />
        <path
            d="M616.333 214H467.333C464.019 214 461.333 216.686 461.333 220C461.333 223.314 464.019 226 467.333 226H616.333C619.647 226 622.333 223.314 622.333 220C622.333 216.686 619.647 214 616.333 214Z"
            fill="#F2F4F7"
        />
        <path
            d="M530.333 234H467.333C464.019 234 461.333 236.686 461.333 240C461.333 243.314 464.019 246 467.333 246H530.333C533.647 246 536.333 243.314 536.333 240C536.333 236.686 533.647 234 530.333 234Z"
            fill="#F2F4F7"
        />
        <path
            d="M611.333 280H487.333C484.019 280 481.333 282.686 481.333 286C481.333 289.314 484.019 292 487.333 292H611.333C614.647 292 617.333 289.314 617.333 286C617.333 282.686 614.647 280 611.333 280Z"
            fill="#F2F4F7"
        />
        <path
            d="M559.333 300H487.333C484.019 300 481.333 302.686 481.333 306C481.333 309.314 484.019 312 487.333 312H559.333C562.647 312 565.333 309.314 565.333 306C565.333 302.686 562.647 300 559.333 300Z"
            fill="#F2F4F7"
        />
        <path
            d="M584.333 320H487.333C484.019 320 481.333 322.686 481.333 326C481.333 329.314 484.019 332 487.333 332H584.333C587.647 332 590.333 329.314 590.333 326C590.333 322.686 587.647 320 584.333 320Z"
            fill="#F2F4F7"
        />
        <path
            d="M24 350.5H190.667C194.809 350.5 198.167 353.858 198.167 358V374C198.167 378.142 194.809 381.5 190.667 381.5H24C19.8579 381.5 16.5 378.142 16.5 374V358C16.5 353.858 19.8579 350.5 24 350.5Z"
            fill="none"
        />
        <path
            d="M469.333 350.5H636C640.142 350.5 643.5 353.858 643.5 358V374C643.5 378.142 640.142 381.5 636 381.5H469.333C465.191 381.5 461.833 378.142 461.833 374V358C461.833 353.858 465.191 350.5 469.333 350.5Z"
            fill="none"
        />
        <path
            d="M469.333 350.5H636C640.142 350.5 643.5 353.858 643.5 358V374C643.5 378.142 640.142 381.5 636 381.5H469.333C465.191 381.5 461.833 378.142 461.833 374V358C461.833 353.858 465.191 350.5 469.333 350.5Z"
            stroke="var(--et-colors-border)"
        />
    </svg>
</template>
